
<style scoped lang="less" >
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 23px !important;
}
.v-application .text-h5 {
  font-family: "Prompt", sans-serif !important;
  font-size: 18px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-data-table__wrapper > table > thead > tr {
  background-color: #039be5;
}
.v-data-table__wrapper > table > thead > tr > th {
  font-size: 14px;
  color: white !important;
}
</style>
<template>
  <v-card>
    <v-card-title>
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        สร้างโซน
      </div>
    </v-card-title>
    <v-card-text>
      <v-divider></v-divider>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12" lg="12" class="my-n5">
              กำหนดชื่อ Zone :
              <v-text-field
                dense
                outlined
                v-model="zname"
                :rules="ru_name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="12" class="my-n5">
              ระบุวันจัดเก็บ :
              <v-radio-group v-model="ztype" row class="mb-n5" :rules="ru_week">
                <v-radio
                  class="pr-6"
                  label="รายเดือน"
                  hide-details
                  value="M"
                ></v-radio>
                <v-radio
                  class="pr-6"
                  label="รายสัปดาห์"
                  hide-details
                  value="W"
                ></v-radio>
              </v-radio-group>
              <v-layout row wrap align-start class="mx-1" v-if="ztype == 'M'">
                <v-checkbox
                  v-for="(item, index) in list_weeks"
                  class="pr-4"
                  v-model="se_week"
                  hide-details
                  :label="item.NAME"
                  :value="item.VALUE"
                  :key="index"
                  :rules="ru_day"
                ></v-checkbox>
              </v-layout>
              <v-layout row wrap align-start class="mx-1">
                <v-checkbox
                  class="pr-4"
                  v-model="all_day"
                  label="เลือกทั้งหมด"
                  hide-details
                  @change="se_all()"
                ></v-checkbox>
                <v-checkbox
                  v-for="(item, index) in list_days"
                  class="pr-4"
                  v-model="days"
                  :label="item.NAME"
                  hide-details
                  :value="item.VALUE"
                  :key="index"
                  @change="se_days()"
                ></v-checkbox>
              </v-layout>
            </v-col>
            <v-col cols="12" lg="12">
              <div
                class="text-h5 font-weight-black text-spacing mb-n10 mt-3"
                color="blue"
              >
                กำหนดพื้นที่
              </div>
            </v-col>
            <v-col cols="12" lg="12" class="mt-4">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" style="width: 3%">ลำดับ</th>
                      <th class="text-left">จังหวัด</th>
                      <th class="text-left">อำเภอ</th>
                      <th class="text-left"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in zone_area" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <v-combobox
                          :items="province"
                          item-text="PROVINCE_NAME"
                          item-value="PROVINCE_NAME"
                          @change="(evt) => list_amphoe(evt)"
                          :menu-props="{ bottom: true, offsetY: true }"
                          v-model="item.PROVINCE"
                          :return-object="false"
                        ></v-combobox>
                      </td>
                      <td>
                        <v-combobox
                          :items="amphoe"
                          style="width: 350px"
                          item-text="DISTRICT_NAME"
                          item-value="DISTRICT_NAME"
                          v-model="item.AREA"
                          :return-object="false"
                          :menu-props="{ bottom: true, offsetY: true }"
                          multiple
                        ></v-combobox>
                      </td>
                      <td>
                        <v-btn icon @click="delete_zone(item)">
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn color="info" elevation="0" small @click="add_zone()">
                <v-icon left>mdi-plus</v-icon>เพิ่มแถวรายการ
              </v-btn>
              <!-- <v-progress-circular
                indeterminate
                color="primary"
                v-if="loading"
              ></v-progress-circular> -->
              <!-- <v-list dense>
                <v-list-item-group>
                  <v-list-item v-for="(item, index) in amphoe" :key="index">
                    <v-list-item-content>
                      <v-checkbox
                        :key="index"
                        class="mt-n1"
                        v-model="se_amphoe"
                        :label="item.DISTRICT_NAME"
                        hide-details
                        :value="item.DISTRICT_NAME"
                      ></v-checkbox>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list> -->
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-divider></v-divider>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="white"
        style="width: 100px"
        light
        elevation="2"
        @click="close()"
      >
        ยกเลิก
      </v-btn>
      <v-btn
        color="success"
        style="width: 100px"
        dark
        elevation="2"
        @click="save()"
      >
        บันทึก
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "ZoneForm",
  data: () => ({
    se_month: "W",
    se_week: ['W3'],
    loading: false,
    days: [],
    all_day: false,
    province: [],
    amphoe: [],
    list_days: [
      { NAME: "อาทิตย์", VALUE: "SUN" },
      { NAME: "จันทร์", VALUE: "MON" },
      { NAME: "อังคาร", VALUE: "TUE" },
      { NAME: "พุธ", VALUE: "WED" },
      { NAME: "พฤหัสบดี", VALUE: "THU" },
      { NAME: "ศุกร์", VALUE: "FRI" },
      { NAME: "เสาร์", VALUE: "SAT" },
    ],
    list_weeks: [
      { NAME: "สัปดาห์ที่ 1", VALUE: "W1" },
      { NAME: "สัปดาห์ที่ 2", VALUE: "W2" },
      { NAME: "สัปดาห์ที่ 3", VALUE: "W3" },
      { NAME: "สัปดาห์ที่ 4", VALUE: "W4" },
    ],
    se_amphoe: [],
    ru_week: [(v) => !!v || ""],
    ru_day: [(v) => !!v || ""],
    ru_name: [(v) => !!v || ""],

  }),
  watch: {},
  filters: {

  },
  computed: {
    ...mapGetters({
      getZoneData: 'Zone/GET_ELEMENT'
    }),
    zname: {
      get() {
        return this.getZoneData.ZONE_NAME;
      },
      set(value) {
        this.setZoneDetail({ key: "ZONE_NAME", value: value });
      },
    },
    ztype: {
      get() {
        return this.getZoneData.ZONE_TYPE;
      },
      set(value) {
        this.setZoneDetail({ key: "ZONE_TYPE", value: value });
      },
    },
    zone_area: {
      get() {
        return this.getZoneData.ZONE_AREA
      }
    }

  },
  created() {

    this.list_province()
  },
  methods: {
    ...mapMutations({
      setZoneDetail: 'Zone/SET_ELEMENT',
      setZoneArea: 'Zone/SET_ZONE_AREA'
    }),
    ...mapActions({
      addZoneArea: 'Zone/add_zone_list',
      delZoneArea: 'Zone/remove_zone_list'
    }),
    close() {
      this.clear_form()
      this.$parent.$parent.$parent.dialog = false
    },
    clear_form() {
      this.$refs.form.reset();
      this.$store.dispatch("Zone/reset");
      this.$parent.$parent.$parent.list_zone()
    },
    save() {
      let zone1 = this.getZoneData
      //  let zones_area = this.list_zone
      let days_data = Object.assign({ MON: "0", TUE: "0", WED: "0", THU: "0", SAT: "0", SUN: "0" }, ...this.days.map(key => ({ [key]: "1" })))
      let zone2 = Object.assign(zone1, days_data)
      let zarea = zone1.ZONE_AREA
      let newarea = []
      for (let i = 0; i < zarea.length; i++) {
        for (let j = 0; j < zarea[i].AREA.length; j++) {
          newarea.push({ ZONE_ID: "", PROVINCE: zarea[i].PROVINCE, AREA: zarea[i].AREA[j] })
        }
      }
      this.setZoneDetail({ key: "NEW_AREA", value: newarea });
      if (this.$refs.form.validate()) {
        this.$token_api
          .post("/insert-zone", zone1)
          .then((response) => {
            this.$swal({ title: "บันทึกสำเร็จ", icon: "success" });
            this.close()
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$swal(
          "เกิดข้อผิดพลาด",
          "กรุณากรอกข้อมูลให้ครบถ้วน",
          "warning"
        );
      }
    },
    se_all() {
      if (this.all_day) {
        this.days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
      } else {
        this.days = []
      }
    },
    se_days() {
      this.all_day = false
    },
    list_province() {
      this.$token_api
        .get("/list-th-province")
        .then((response) => {
          // console.log()
          this.province = response.data.data
        })
        .catch((err) => {

        });
    },
    add_zone() {
      //   let arr_zone = this.list_zone
      //   arr_zone.push({ ZONE_ID: "", PROVINCE: "", AREA: [] })
      this.addZoneArea({ ZONE_ID: "", PROVINCE: "", AREA: [] })
    },
    delete_zone(item) {
      //   let data = this.list_zone;
      //   const index = data.indexOf(item);
      //   data.splice(index, 1);
      this.delZoneArea(item)
    },
    list_amphoe(item) {

      this.loading = true
      this.amphoe = []
      this.se_amphoe = []

      if (item) {
        let province = item
        this.$token_api
          .post("/list-th-amphoe", { PROVINCE: province })
          .then((response) => {

            this.amphoe = response.data.data
            // this.se_amphoe = []
            this.loading = false
          })
          .catch((err) => {

          });

      }

    },
  },

  mounted() {
  },
};
</script>